/* BOXO – ventelisteknappen (back in stock) skal ikke åpne EliteCart-handlekurven.
   EliteCart binder seg direkte til knappen, så vi lukker skuffen rett etter klikket. */
(function () {
  function fiks() {
    document.querySelectorAll('button.gw-button-widget').forEach(function (btn) {
      btn.type = 'button';
      btn.classList.remove('add-to-cart');
    });
  }
  fiks();
  new MutationObserver(fiks).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('button.gw-button-widget')) return;
    [100, 400, 900, 1500].forEach(function (ms) {
      setTimeout(function () {
        if (window.EliteCart && window.EliteCart.closeDrawer) window.EliteCart.closeDrawer();
      }, ms);
    });
  }, true);
})();